import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { FaBan } from "react-icons/fa";
import { cancelPurchaseOrder, getPurchaseOrder } from "redux/erp/purchaseOrderSlice";
import { Modal, Button, FormInput } from 'components/common';

// Khác với Reject (người ký từ chối tại bước ký) — Cancel là người lập tự huỷ
// HẲN phiếu của mình (còn draft hoặc đang pending). Cả 2 đều là trạng thái cuối:
// không sửa/submit lại được, muốn làm lại thì Duplicate sang phiếu mới.
const CancelForm = ({ show, onHide, purchaseOrder }) => {
  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async () => {
    setBusy(true);
    try {
      await dispatch(cancelPurchaseOrder({ id: purchaseOrder.id, comment })).unwrap();
      await dispatch(getPurchaseOrder(purchaseOrder.id));
      toast.success("Purchase order canceled.");
      onHide();
    } catch (e) { toast.error(e?.error || e?.message || "Cancel failed."); }
    finally { setBusy(false); }
  };

  return (
    <Modal show={show} onHide={onHide} title={`Cancel ${purchaseOrder?.code}`} size="md"
      footer={<>
        <Button variant="secondary" size="sm" disabled={busy} onClick={onHide}>Back</Button>
        <Button variant="danger" size="sm" leftIcon={FaBan} disabled={busy} onClick={onSubmit}>Cancel order</Button>
      </>}>
      <div className="geist-scope">
        <p className="tw-text-sm tw-text-geist-fg-2 tw-mt-0">
          This permanently cancels the order — it can no longer be edited or submitted.
          Use Duplicate afterwards if you want to reuse its content in a new order.
        </p>
        <FormInput label="Cancel reason (optional)" type="textarea" rows={3} value={comment} onChange={(e) => setComment(e.target.value)} />
      </div>
    </Modal>
  );
};

CancelForm.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    code: PropTypes.string,
  }).isRequired,
};

export default CancelForm;
